import * as React from "react";
import Ajax from "../../Ajax";
import swal from 'sweetalert';
import InputMask from 'react-input-mask';
import ReactBnbGallery from 'react-bnb-gallery'
import 'react-bnb-gallery/dist/style.css'
import Modal from 'react-modal';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';


interface IFormProps {
  service: object,
  loadCart: any,
  session_id: any,
  serial: number,
}
interface MyStates {
  ajaxLoaded: boolean,
  chosen_time: string,
  galleryOpened: boolean
  photos: [],
  modalIsOpen: boolean,
  date: {},
  availableTime: [],
  time: {}
}
export default class Service extends React.Component<IFormProps, MyStates>{
  private customStyles: object;
  constructor(props:IFormProps) {
    super(props);


    this.state = {
      ajaxLoaded: true,
      chosen_time: '',
      galleryOpened: false,
      photos: [],
      modalIsOpen: false,
      date: new Date(new Date((new Date).getTime() + 86400000)),
      time: '',
      availableTime: [],
    }

    this.customStyles = {
      content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)',
        width                 : '1100px'
      }
    };
    
    this.toggleGallery = this.toggleGallery.bind(this);

    // this.setSelectedServices();
    
  }

  toggleGallery(gallery) {
    this.setState(prevState => ({
      photos: gallery,
      galleryOpened: !prevState.galleryOpened
    }));
  }

  private getTime(){
    let time = this.props.service?.['period'] ?? 0
    if( time >= 60 && time % 60 == 0){
      return (time/60) + ' óra'
    }
    return time + ' perc'
  }

  private getPrice(){
    let price = this.props.service?.['price'] ?? 0

    if( price == 0 ){
      return (
        <div className="price">Díjtalan</div>
      )
    } else {
      return (
        <div className="price">{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} Ft</div>
      )
    }
  }

  private chose(){
    let date = '';
    if(this.props.service?.['period'] == 0){
      date = '';
    }
    else{
      date = this.formatDate(this.state.date) + ' ' + this.state.time;
    }
 
    var ajax = new Ajax(window.location.origin+ '/api/ordering/addServiceToCart');
    ajax.doPost({session_id: this.props.session_id, service_id: this.props.service?.['id'], service_serial: this.props.serial, date: date}).then((response) => {
      if( response.status !== undefined && response.status === 'success' ){
        swal({
          title: "Szolgáltatás hozzáadva a rendeléshez!",
          icon: "success",
        });
      } else {
        swal({
          title: "Hiba történt!",
          text: response.message,
          icon: "error",
        });
      }

      this.props.loadCart()

      this.setState({
        modalIsOpen: false,
      })

    })

  }


  private setModal(state) {
    this.setServiceDate(this.state.date);
    this.setState({
      modalIsOpen: state,
      availableTime:[]
    })

  }

  formatDate(date) {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}

  setServiceDate(date) {
    console.log(this.props.service);
    var ajax = new Ajax(window.location.origin+ '/api/ordering/getAvailableTime');
    ajax.doPost({selectdate: this.formatDate(date), service: this.props.service, session_id: this.props.session_id}).then((response) => {
    
      this.setState({
        date: date,
        availableTime: response,
        time:''
      })
    })

  }

  setServiceTime(time){
    this.setState({
      time:time
    });
  
  }

  public render() {
    let service = this.props.service
    let [month, date, year]    = new Date().toLocaleDateString("en-US").split("/")

    return(
      <>
        <div className="col-md-2 img form-group">
          <img style={{cursor:'pointer', width: '100%'}} onClick={() => this.toggleGallery(service?.['gallery'])} src={'/'+service?.['main_image']} />
          <ReactBnbGallery
            show={this.state.galleryOpened} 
            photos={this.state.photos}
            onClose={() => this.toggleGallery(service?.['gallery'])} />
        </div>
        <div className="col-md-10 form-group place">
          
          <h3>{service?.['name']}</h3>
          <span className="time" style = {{marginBottom: '5px', display: 'block'}}>Időtartam: {this.getTime()}</span>

          <p>{service?.['description']}</p>
          <div className="row">
            <div className="col-12 col-lg-4 form-group">
              {this.getPrice()}
            </div>
            <div className="col-8 col-lg-5 form-group">
            </div>
            <div className="col-4 col-lg-3 form-group">
              {service?.['period'] == 0
              ?
                <button onClick={() => this.chose()}  type="button" className="btn btn-primary btn-block" >Kiválasztom</button>
              :
                <button onClick={() => this.setModal(true)}  type="button" className="btn btn-primary btn-block" >Kiválasztom</button>
              } 
            </div>
          </div>
        </div>
        <div style={{clear: 'both'}}></div>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={() => {}}
          onRequestClose={() => this.setModal(false)}
          style={this.customStyles}
          contentLabel="Example Modal"
          ariaHideApp={false}
        >
          <div className="row">
            <div className="col-md-4 img form-group">
              <img style={{width:'100%'}} src={'/'+service?.['main_image']} />
            </div>
            <div className="col-md-8 form-group">
              <h4>{service?.['name']}</h4>
              <span>{service?.['description']}</span>
              {this.getPrice()}
            </div>
          </div>
          <div className="row">
          <div className="col-md-5 form-group">
            <Calendar 
              value={this.state.date}        
              onClickDay={(e) => this.setServiceDate(e)}
              minDate={new Date((new Date).getTime() + 86400000)}    
        
            />
          </div>
          <div className="col-md-7 form-group">
            <div className="col-md-12">
            <span style={{marginBottom: '20px', display: 'block'}}>Időtartam: <b>{this.getTime()}</b></span>
            
            {  this.state.availableTime.length > 0 ? 
              <>
              <p><b>Elérhető időpontok:</b></p>
              <ul style={{columns: '4', listStyleType: 'none'}}>
              {this.state.availableTime.map((time, i) => (
                <li key={i}>
                  <label>
                    <input type="radio" name="time" onChange={() => this.setServiceTime(time['start_date'])}  value={time['start_date']} />
                    <span style={{marginTop: '1px', marginLeft: '3px'}}>{time['start_date'] + ' - ' + time['end_date']}</span>
                  </label>
                </li>
              )) }
              </ul>
              </> 
              :
              <div className="alert alert-danger">
                Sajnos minden időpont foglalt erre a napra! 
              </div>

            }
            
            </div>
          </div>
          
          </div>
          { this.state.time &&
            <div className = "row">
              <div className="col-md-12 text-center">
                <button type = "button" className="btn btn-success btn-lg" onClick={() => this.chose()}>Kiválasztom az időpontot</button>
              </div>
            </div>
          }
          
         

        </Modal>
      </>
    )
  }
}